import { render, staticRenderFns } from "./PluginsDatatable.vue?vue&type=template&id=ca452c04"
import script from "./PluginsDatatable.vue?vue&type=script&lang=js"
export * from "./PluginsDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports